import { Buffer } from "buffer";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ToastContainer } from "react-toastify";
import * as serviceworker from './serviceWorker';
import App from "./App";

window.Buffer = Buffer;

const isHttpAuthNoise = (err) => {
	const status = err?.response?.status || err?.reason?.response?.status;
	const message = err?.message || err?.reason?.message || "";
	return status === 401 || status === 403 || /Request failed with status code (401|403)/.test(message);
};

window.addEventListener(
	"unhandledrejection",
	(event) => {
		if (isHttpAuthNoise(event.reason)) {
			event.preventDefault();
			event.stopImmediatePropagation();
		}
	},
	true
);

window.addEventListener(
	"error",
	(event) => {
		if (isHttpAuthNoise(event.error) || isHttpAuthNoise({ message: event.message })) {
			event.preventDefault();
			event.stopImmediatePropagation();
		}
	},
	true
);

ReactDOM.render(
	<>
		<CssBaseline />
		<App />
		<ToastContainer
			position="top-center"
			autoClose={3000}
			style={{ zIndex: 99999 }}
		/>
	</>,
	document.getElementById("root"),
	() => {
		window.finishProgress();
	}
);

// Desabilita o Service Worker para evitar cache agressivo e erro de MIME em dev/prod
serviceworker.unregister();
